import {
  LoadingOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import { Button, Card, Col, Divider, Flex, Form, Row, Spin, Upload } from "antd";
import { Footer } from "antd/es/layout/layout";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { useForm } from "antd/es/form/Form";
import { getBase64 } from "components/elements/upload/Upload.utils";
import { FormDatePicker, FormInput, FormInputIdentification, FormRadio, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useEffect, useState } from "react";
import { formatDate } from "utils/formatter";
import { formatIdCard, requestIdCard } from "utils/formatter/formatCommon";
import { dataURLtoFile } from "utils/helper";
import { NATIONALITY } from "../schemas/employeeCreateSchema";
import schema from "../schemas/employeeInfoGeneralSchema";
import * as service from "../services/employeeApi";
import styles from "../styles/EmployeeForm.module.css";

function EmployeeInfoGeneralForm({
  raceOptions = [],
  initialValues = {},
  religionOptions = [],
  genderOptions = [],
  titleNameOptions = [],
  titleNameEnOptions = [],
  bloodGroupOptions = [],
  nationalityOptions = [],
  maritalStatusOptions = [],
  militaryStatusOptions = [],
  countryOptions = [],
  visaTypeOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
  ss = () => { },
  gift = () => { },
  dog = () => { },
  isLoading = false
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState();
  // const [radioValue, setRadioValue] = useState(NATIONALITY.DOMESTIC);
  const [formUse] = useForm();
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        {t("common.upload")}
      </div>
    </button>
  );

  const beforeUpload = (file) => {
    return false;
  };

  const colStyle = {
    xs: {
      flex: '100%',
    },
    sm: {
      flex: '50%',
    },
    md: {
      flex: '50%',
    },
    lg: {
      flex: '25%',
    },
    xl: {
      flex: '25%',
    }
  }

  const colInfoStyle = {
    xs: {
      flex: '100%',
    },
    sm: {
      flex: '50%',
    },
    md: {
      flex: '50%',
    },
    lg: {
      flex: '33%',
    },
    xl: {
      flex: '33%',
    }
  }

  const colVisaStyle = {
    xs: {
      flex: '100%',
    },
    sm: {
      flex: '50%',
    },
    md: {
      flex: '50%',
    },
    lg: {
      flex: '20%',
    },
    xl: {
      flex: '20%',
    }
  }
  useEffect(() => {
    if (initialValues?.employeeImage && initialValues?.employeeImage !== "" && initialValues?.employeeImage !== null) {
      setLoading(true);
      getBase64(initialValues?.employeeImage, (url) => {
        setImageUrl(url);
      });
    }
  }, [initialValues.employeeImage]);

  useEffect(() => {
    if (initialValues) {
      const newValues = {
        ...initialValues,
        identificationNo: formatIdCard(initialValues?.identificationNo ? initialValues?.identificationNo : '-')
      };
      formUse.setFieldsValue(newValues);
    }
  }, [initialValues, formUse]);

  return (
    <Spin spinning={isLoading}>
      <FormAntd
        initialValues={initialValues}
        onFinish={onSubmit}
        validationSchema={schema}
        form={formUse}
      >
        <Form.Item shouldUpdate={(prev, curv) => {
          // if (prev["employeeNationality"] != curv["employeeNationality"])
          // console.log(prev["employeeNationality"] != curv["employeeNationality"]);
          if (prev['dateOfBirth'] !== curv['dateOfBirth']) {
            const date2 = dayjs();
            curv['age'] = date2.diff(curv['dateOfBirth'], 'year')
            // curv['age'] = curv['employmentDate'].add(119 + (curv['extensionProbation'] == 'Y' ? curv['daysProbation'] : 0), 'day')
          }

          return prev["employeeNationality"] !== curv["employeeNationality"]
            || prev["dateOfBirth"] !== curv["dateOfBirth"]
            || prev["age"] !== curv["age"]
        }}>
          {({ getFieldValue, setFieldValue }) => {
            const onAvatarChange = async (info) => {
              setLoading(true);
              const compressImg = await service.compressedImage({
                file: info.file
              })
              getBase64(compressImg.data, (url) => {
                console.log("url2 ", url);
                setLoading(false);
                setFieldValue("employeeImage", dataURLtoFile(url));
                setImageUrl(url);
              });
            };

            const onClearAvatar = (e) => {
              e.stopPropagation();
              setFieldValue("employeeImage", null);
              setLoading(false);
              setImageUrl(null);
            };

            return (
              <div>
                <Card>
                  <Flex gap={24}>
                    <Flex justify="center">
                      <Form.Item name={"employeeImage"}>
                        <Upload
                          name="avatar"
                          listType="picture-circle"
                          className={styles.avatarUploader}
                          showUploadList={false}
                          beforeUpload={beforeUpload}
                          onChange={onAvatarChange}
                          action={null}
                        >
                          {imageUrl ? (
                            <>
                              <img
                                src={imageUrl}
                                alt="avatar"
                                className={styles.avatar}
                                style={{
                                  width: "100%",
                                }}
                              />
                              <MinusCircleOutlined
                                className={styles.avatarMinusIcon}
                                onClick={onClearAvatar}
                              />
                            </>
                          ) : (
                            uploadButton
                          )}
                        </Upload>
                      </Form.Item>
                    </Flex>

                    <Flex vertical style={{ rowGap: "16px" }}>
                      <div>
                        <Row>
                          <span style={{ fontSize: "18px", fontWeight: "bold" }}>{t('edit-name')}</span>
                        </Row>
                        <Row>
                          <span style={{ fontSize: "16px", fontWeight: "bold", alignSelf: "flex-start" }}>
                            {t('thai-name')}
                          </span>
                        </Row>
                        <Row gutter={[24, 0]}>
                          <Col {...colStyle}>
                            <FormSelect
                              required={true}
                              name="titleId"
                              label={t("employee.label.title_th")}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              options={titleNameOptions} />
                          </Col>
                          <Col {...colStyle}>
                            <FormInput
                              required={true}
                              name="name"
                              label={t('employee.name-th')}
                              placeholder={t('employee.name-th')}
                              size="large" />
                          </Col>
                          <Col {...colStyle}>
                            <FormInput
                              required={true}
                              name="surName"
                              label={t('surname-th')}
                              placeholder={t('surname-th')}
                              size="large" />
                          </Col>
                          <Col {...colStyle}>
                            <FormInput
                              name="nickName"
                              label={t('employee.nickname-th')}
                              placeholder={t('employee.nickname-th')}
                              size="large" />
                          </Col>
                        </Row>
                      </div>

                      <div>
                        <Row>
                          <span style={{ fontSize: "16px", fontWeight: "bold", alignSelf: "flex-start" }}>
                            {t('english-name')}
                          </span>
                        </Row>
                        <Row gutter={[24, 0]}>
                          <Col {...colStyle}>
                            <FormSelect
                              required={true}
                              name="titleId"
                              label={t("employee.label.title_en")}
                              placeholder={t('common.pleaseSelect')}
                              size="large"
                              options={titleNameEnOptions} />
                          </Col>
                          <Col {...colStyle}>
                            <FormInput
                              required={true}
                              name="nameEn"
                              label={t('name-en')}
                              placeholder={t('name-en')}
                              size="large" />
                          </Col>
                          <Col {...colStyle}>
                            <FormInput
                              required={true}
                              name="surNameEn"
                              label={t('employeeInfo.surname-en')}
                              placeholder={t('employeeInfo.surname-en')}
                              size="large" />
                          </Col>
                          <Col {...colStyle} >
                            <FormInput
                              name="nickNameEn"
                              label={t('employeeInfo.nickname-en')}
                              placeholder={t('employeeInfo.nickname-en')}
                              size="large" />
                          </Col>
                        </Row>
                      </div>

                      <Divider className={styles.customDivider} />

                      <Row>
                        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                          {t('personal-information')}
                        </span>
                      </Row>
                      <Row gutter={[24, 0]}>
                        <Col span={24}>
                          <FormRadio
                            required={true}
                            name="employeeNationality"
                            label={t("employee.label.employee_nationality")}
                            options={[
                              {
                                label: t("employee.label.domestic"),
                                value: NATIONALITY.DOMESTIC,
                              },
                              {
                                label: t("employee.label.foreigner"),
                                value: NATIONALITY.FOREIGNER,
                              },
                            ]} />
                        </Col>
                      </Row>
                      <Row gutter={[24, 0]} style={{ paddingTop: "8px" }}>
                        {getFieldValue("employeeNationality") === NATIONALITY.DOMESTIC ?
                          <Col xs={24} sm={12}>
                            <FormInputIdentification
                              required={true}
                              name="identificationNo"
                              label={t("employee.label.identification_id")}
                              placeholder={t("employee.label.identification_id")}
                              numberOnly={true}
                              controls={false}
                              direction="ltr"
                              maxLength={17}
                              size="large"
                              form={formUse}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (value && requestIdCard(value).length !== 13) {
                                      return Promise.reject(new Error(t('employee.error.req_thirteen')));
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            />
                          </Col>
                          : null}
                        {getFieldValue("employeeNationality") === NATIONALITY.FOREIGNER ?
                          <Col xs={24} sm={12}>
                            <FormInputIdentification
                              required={true}
                              name="taxId"
                              label={t("employee.label.tax_id")}
                              placeholder={t("employee.label.tax_id")}
                              size="large"
                              form={formUse}
                              maxLength={17}
                              rules={[
                                ({ getFieldValue }) => ({
                                  validator(_, value) {
                                    if (value && requestIdCard(value).length !== 13) {
                                      return Promise.reject(new Error(t('employee.error.req_thirteen_tax')));
                                    }

                                    return Promise.resolve();
                                  },
                                }),
                              ]}
                            />
                          </Col>
                          : null}
                      </Row>

                      {getFieldValue("employeeNationality") === NATIONALITY.FOREIGNER ?
                        <>
                          {/* --- Passport --- */}
                          <Row gutter={[24, 0]}>
                            <Col {...colStyle}>
                              <FormInput
                                required
                                name="passportNo"
                                label={t('employment-information.label.passportNo')}
                                placeholder={t('employment-information.label.passportNo')}
                                size="large"
                              />
                            </Col>
                            <Col {...colStyle}>
                              <FormSelect
                                required
                                name="passportIssueCountryId"
                                label={t('employment-information.label.passportIssueCountry')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                options={countryOptions}
                              />
                            </Col>
                            <Col {...colStyle}>
                              <FormDatePicker
                                name="passportIssueDate"
                                label={t('employment-information.label.passportIssueDate')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                format={formatDate()}
                              />
                            </Col>
                            <Col {...colStyle}>
                              <FormDatePicker
                                required
                                name="passportExpireDate"
                                label={t('employment-information.label.passportExpireDate')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                format={formatDate()}
                              />
                            </Col>
                          </Row>

                          {/* --- Visa --- */}
                          <Row gutter={[24, 0]}>
                            <Col {...colVisaStyle}>
                              <FormSelect
                                // required
                                name="visaTypeId"
                                label={t('employment-information.label.visaType')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                options={visaTypeOptions}
                              />
                            </Col>
                            <Col {...colVisaStyle}>
                              <FormInput
                                // required
                                name="visaNo"
                                label={t('employment-information.label.visaNo')}
                                placeholder={t('employment-information.label.visaNo')}
                                size="large"
                              />
                            </Col>
                            <Col {...colVisaStyle}>
                              <FormSelect
                                // required
                                name="visaIssueCountryId"
                                label={t('employment-information.label.visaIssueCountry')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                options={countryOptions}
                              />
                            </Col>
                            <Col {...colVisaStyle}>
                              <FormDatePicker
                                name="visaIssueDate"
                                label={t('employment-information.label.visaIssueDate')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                format={formatDate()}
                              />
                            </Col>
                            <Col {...colVisaStyle}>
                              <FormDatePicker
                                // required
                                name="visaExpireDate"
                                label={t('employment-information.label.visaExpireDate')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                format={formatDate()}
                              />
                            </Col>
                          </Row>

                          {/* --- Work Permit --- */}
                          <Row gutter={[24, 0]}>
                            <Col {...colInfoStyle}>
                              <FormInput
                                name="workPermitNo"
                                label={t('employment-information.label.workPermitNo')}
                                placeholder={t('employment-information.label.workPermitNo')}
                                size="large"
                              // required
                              />
                            </Col>
                            <Col {...colInfoStyle}>
                              <FormDatePicker
                                name="workPermitIssueDate"
                                label={t('employment-information.label.workPermitIssueDate')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                format={formatDate()}
                              />
                            </Col>
                            <Col {...colInfoStyle}>
                              <FormDatePicker
                                // required
                                name="workPermitExpireDate"
                                label={t('employment-information.label.workPermitExpireDate')}
                                placeholder={t('common.pleaseSelect')}
                                size="large"
                                format={formatDate()}
                              />
                            </Col>
                          </Row>
                        </>
                        : null}
                      <Row gutter={[24, 0]}>
                        <Col {...colInfoStyle}>
                          <FormSelect
                            required={true}
                            name="genderId"
                            label={t('gender-1')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={genderOptions} />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormDatePicker
                            required={true}
                            name="dateOfBirth"
                            label={t('date-of-birth')}
                            placeholder={t('common.placeholder.ddmmyyyy')}
                            size="large"
                            onChange={(e) => {
                              const date2 = dayjs();
                              let years = date2.diff(e, 'year');

                              setFieldValue('age', years)
                            }}
                            format={formatDate()} />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormInput
                            disabled
                            required={true}
                            name="age"
                            label={t('employee.age-0')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                          />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormSelect
                            name="raceId"
                            label={t('employee.race')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={raceOptions}
                            allowClear
                          />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormSelect
                            required={true}
                            name="nationalityId"
                            label={t('employee.nationality')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={nationalityOptions}
                          />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormSelect
                            name="religionId"
                            label={t('employee.religion')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={religionOptions}
                            allowClear
                          />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormSelect
                            required={true}
                            name="maritalStatusId"
                            label={t('employee.marital-status')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={maritalStatusOptions} />
                        </Col>
                        {/* {values.genderCo == 'BANK' ? */}
                        <Col {...colInfoStyle}>
                          <FormSelect
                            // required={true}
                            name="militaryStatusId"
                            label={t('employee.military-status-0')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={militaryStatusOptions}
                            allowClear />
                        </Col>
                        {/* : null} */}
                        <Col {...colInfoStyle}>
                          <FormInput
                            name="weight"
                            label={t('employee.weight')}
                            placeholder={t('weight')}
                            size="large"
                            numberOnly={true}
                          />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormInput
                            name="height"
                            label={t('height-0')}
                            placeholder={t('height-0')}
                            size="large"
                            numberOnly={true}
                          />
                        </Col>
                        <Col {...colInfoStyle}>
                          <FormSelect
                            name="bloodGroupId"
                            label={t('employee.blood-group')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={bloodGroupOptions}
                            allowClear />
                        </Col>
                      </Row>
                      <Row gutter={[24, 0]}>
                        <Col span={24}>
                          <FormInput
                            name="remark"
                            label={t('remark-0')}
                            placeholder={t('remark')}
                            size="small"
                            type="textarea" />

                        </Col>
                      </Row>
                    </Flex>
                  </Flex>
                </Card>

                {/* -------------------------------------------------------------------- */}

                <Footer style={{
                  zIndex: 999,
                  bottom: 2,
                  position: 'sticky',
                  backgroundColor: 'white',
                  height: "max-content",
                  placeContent: "center"
                }}>
                  <Row justify="end" style={{ gap: "12px" }}>
                    <Button type="default" onClick={() => {
                      onCancel()
                    }} style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}
                    >
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button type="primary" htmlType="submit" style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
                      {t("common.submit").toUpperCase()}
                    </Button>
                  </Row>
                </Footer>
              </div>
            );
          }}
        </Form.Item>
      </FormAntd>
    </Spin>
  );
}

export default EmployeeInfoGeneralForm;